import { BreezeIntelligenceKitProviderNext } from 'breeze-intelligence-kit/components/BreezeIntelligenceKitProvider';
import { CurrentUserProvider } from 'policy-lib';
import { EnrichmentCreditsProvider } from '../EnrichmentCreditsProvider';
import { EnrichmentSettingsProvider } from '../EnrichmentSettingsProvider';
import { EnrichableObjectTypeProvider } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const BreezeIntelligenceEnrichmentProvider = ({
  children
}) => /*#__PURE__*/_jsx(CurrentUserProvider, {
  children: /*#__PURE__*/_jsx(BreezeIntelligenceKitProviderNext, {
    children: /*#__PURE__*/_jsx(EnrichableObjectTypeProvider, {
      children: /*#__PURE__*/_jsx(EnrichmentSettingsProvider, {
        children: /*#__PURE__*/_jsx(EnrichmentCreditsProvider, {
          children: children
        })
      })
    })
  })
});